import * as Yup from 'yup';
// eslint-disable-next-line func-names
Yup.addMethod(Yup.number, 'sequence', function(funcList) {
  return this.test(async (value, context) => {
    try {
      // eslint-disable-next-line no-restricted-syntax
      for (const func of funcList) {
        // eslint-disable-next-line no-await-in-loop
        await func().validate(value);
      }
    } catch ({ message }) {
      return context.createError({ message });
    }
    return true;
  });
});

// eslint-disable-next-line import/prefer-default-export
export const AddMasterListProductSchema = Yup.object().shape({
  averagePricePerUnit: Yup.number()
    .typeError('List Price must be a number')
    .min(0, 'List Price must be a positive number')
    .notRequired(),
  packageWeight: Yup.number()
    .sequence([
      () => Yup.number().notOneOf([0], 'Weight cannot be 0'),
      () => Yup.number().moreThan(0, 'Weight must be a positive number')
    ])
    .typeError('Weight must be a number')
});
